<script setup lang="ts">
import { ALButton, ALModal } from "@af-lib/vue-ui"
import { globalActor } from "@/machines/globalMachine"
import { useLeaveAppModalStore } from "./leaveAppModal.store"
import { storeToRefs } from "pinia"

const { isActive } = storeToRefs(useLeaveAppModalStore())

function onValid() {
  globalActor.send({ type: "GLOBAL.STEPPER.EXIT" })
}
</script>

<template>
  <ALModal
    v-model="isActive"
    size="l"
    variant="default"
    headerIcon="fat fa-door-open"
  >
    <template #header>
      <span class="text-af-grey-800 font-bold">
        {{ $t("general.quit.assessment.title") }}
      </span>
    </template>
    <template #content>
      <p class="text-af-grey-800 text-base font-light">
        {{ $t("general.quit.assessment.body") }}
      </p>
    </template>

    <template #footer>
      <ALButton type="tertiary" @click="isActive = false">
        {{ $t("general.quit.stay") }}
      </ALButton>
      <ALButton @click="onValid">
        {{ $t("general.quit.leave") }}
      </ALButton>
    </template>
  </ALModal>
</template>
